import { useEffect, useRef, useState } from "react";

export function useVersionCheck(intervalMs = 60_000) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const currentVersion = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();

        if (currentVersion.current === null) {
          // First check - store current version
          currentVersion.current = data.version;
        } else if (data.version !== currentVersion.current) {
          // Version changed - update available
          setUpdateAvailable(true);
        }
      } catch {
        // Ignore fetch errors
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  const applyUpdate = () => {
    // Clear all caches and hard reload
    if ("caches" in window) {
      caches.keys().then(names => names.forEach(name => caches.delete(name)));
    }
    window.location.reload();
  };

  return { updateAvailable, applyUpdate };
}
